import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import CTA from '@/lib/CTA'

const HeroVideo = ({ heading, _rawRichtext, cta, videoUrl, pattern }) => (
	<section className={`${pattern} border-r-[24px] md:border-r-[64px] border-orange`}>
		<div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row gap-12 items-center overflow-hidden py-24 px-4">
			<div data-aos="fade-right" className="max-w-[650px] mx-auto p-4 richtext z-10 text-white">
				<HTag className="h1" {...heading} />
				<Richtext raw={_rawRichtext} />
				<p><CTA {...cta} /></p>
			</div>

			<figure data-aos="fade-left" className="text-right z-10 max-w-[560px] w-full">
				<iframe className="aspect-video w-full" src={videoUrl}></iframe>
			</figure>
		</div>

	</section>
)

export default HeroVideo
